import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data245eeyny59bq1 as Data } from '../DeletePairAssignmentsMutation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.s6l_1 = listOf('deletePairAssignments');
      }
      g40(reader, customScalarAdapters) {
        var _deletePairAssignments = null;
        $l$loop: while (true) {
          if (reader.e4f(this.s6l_1) === 0)
            _deletePairAssignments = get_NullableBooleanAdapter().g40(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_deletePairAssignments);
      }
      t6l(writer, customScalarAdapters, value) {
        writer.c4d('deletePairAssignments');
        get_NullableBooleanAdapter().l40(writer, customScalarAdapters, value.g6h_1);
      }
      h40(writer, customScalarAdapters, value) {
        return this.t6l(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance17eky330o03un,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsMutation_ResponseAdapter.mjs.map
